import { render, staticRenderFns } from "./fenxiao_team.vue?vue&type=template&id=44936734&scoped=true"
import script from "./fenxiao_team.vue?vue&type=script&lang=js"
export * from "./fenxiao_team.vue?vue&type=script&lang=js"
import style0 from "./fenxiao_team.vue?vue&type=style&index=0&id=44936734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44936734",
  null
  
)

export default component.exports